/* eslint-disable no-plusplus */
/* eslint-disable no-console */
// eslint-disable-next-line no-use-before-define
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Paper, Box, Typography,
  Grid, Link, Stack, Select,
  MenuItem, IconButton,
  Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, CircularProgress,
} from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { colors } from '../../services/colors';
import Modal from '../../components/Modal';
import Input from '../../components/input';
import ButtonTemplate from '../../components/Button/Button';
import BackTitle from '../../components/BackTitle';
import { SnackbarAlert } from '../../components/SnackbarAlert';
import { getCategorias, postSolicitacao } from '../../services/solicitacaoAPI';
import { Categoria, Solicitacao } from '../models';
import { LoginStore } from '../../services/zustandProvider';

// 'success' | 'error' | 'warning' | 'info'
export default function NovaSolicitacao() {
  const history = useHistory();
  const { userAtivo, setUserAtivo } = LoginStore();
  const [showModal, setShowModal] = useState(false);
  const [showModalSize, setShowModalSize] = useState(false);
  const [dados, setDados] = useState(new Solicitacao());
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState<any[]>([]);
  const [categoria, setCategoria] = useState<any>('');
  const [categorias, setCategorias] = useState<any>([]);
  const [snackTrue, setSnackTrue] = useState({
    open: false,
    massage: 'salvo com sucesso',
    tipo: 'success',
  });
  const [snackFalse, setSnackFalse] = useState({
    open: false,
    massage: 'erro ao salvar',
    tipo: 'success',
  });
  const [saveLoading, setSaveLoading] = useState(false);
  const [descricaoError, setDescricaoError] = useState({
    status: false,
    massage: 'salvo com sucesso',
  });

  function erros(formErros: any) {
    console.log('teste');
    formErros.forEach((e: any) => {
      if (e.propertyName === 'Descricao') {
        setDescricaoError({ status: true, massage: e.errorMessage });
      } else if (e.propertyName === 'AdicionarSolicitacao') {
        setSnackFalse((prev) => ({ ...prev, massage: e.errorMessage }));
      }
    });
  }

  function FormatForm() {
    const formData = new FormData();
    formData.append('descricao', dados.descricao);
    formData.append('dataCriacao', new Date().toJSON());
    formData.append('categoria', categoria);
    formData.append('CPFUsuario', userAtivo.cpf);
    formData.append('emailUsuario', userAtivo.email);
    files.forEach((e: any, index: number) => {
      formData.append(index.toString(), e);
    });
    return (formData);
  }

  async function EnviarSolicitacao() {
    console.log('teste');
    setSaveLoading(true);
    const postForm = await postSolicitacao(FormatForm());
    console.log(postForm);
    if (postForm.sucesso) {
      console.log(postForm.sucesso);
      setSnackTrue((prev) => ({ ...prev, open: true }));
      history.push('/Dash');
    } else {
      setSnackFalse((prev) => ({ ...prev, open: true }));
      erros(postForm.erros);
    }
    setSaveLoading(false);
  }

  useEffect(() => {
    async function get() {
      console.log(new Date().toJSON());
      const categoriaRetorno = await getCategorias();
      console.log(categoriaRetorno);
      if (categoriaRetorno?.dados) {
        setCategorias(categoriaRetorno?.dados);
        setCategoria(categoriaRetorno?.dados[0].categoriaSolicitacaoId);
        console.log();
      }
    } get();
  }, []);

  function removeItem(index: number) {
    const newfiles = [...files];
    newfiles.splice(index, 1);
    setFiles(newfiles);
  }

  function openfileDialog() {
    const input = document.createElement('input');
    input.type = 'file';
    const newfiles = [...files];
    input.onchange = (_) => {
      // you can use this method to get file and perform respective operations
      if (input?.files) {
        if (input?.files[0].size > 5000000) {
          setShowModalSize(true);
        } else {
          newfiles.push(input?.files[0]);
        }
      }
      setFiles(newfiles);
    };
    input.click();
  }

  return (
    <>
      <SnackbarAlert
        open={snackTrue.open}
        tipo="success"
        message={snackTrue.massage}
        handleClose={() => setSnackTrue((prev) => ({ ...prev, open: false }))}
      />
      <SnackbarAlert
        open={snackFalse.open}
        tipo="error"
        message={snackFalse.massage}
        handleClose={() => setSnackFalse((prev) => ({ ...prev, open: false }))}
      />
      <BackTitle title="Nova solicitação" icon={<NoteAddIcon sx={{ color: colors.themePrimary, fontSize: '30px', marginLeft: '10px' }} />} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8}>
          <Select
            value={categoria}
            onChange={(e) => setCategoria(e.target.value)}
            input={<Input inputColor="black" labelSuperior="Categoria" value="" mensagem="" error={false} />}
          >
            {categorias.map((e: Categoria) => (
              <MenuItem value={e.categoriaSolicitacaoId} key={e.categoriaSolicitacaoId}>
                {e.descricao}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input inputColor="black" labelSuperior="data de criação" value={new Date().toLocaleDateString()} mensagem="" error={false} disabled />
        </Grid>
        <Grid item xs={12}>
          <Input
            inputColor="black"
            multiline
            rows={6}
            labelSuperior="Descrição"
            value={dados.descricao}
            onChange={(e) => setDados((prev) => ({ ...prev, descricao: e.target.value }))}
            mensagem={descricaoError.massage}
            error={descricaoError.status}
          />
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={() => openfileDialog()}
          >
            <AttachFileIcon color="primary" />
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          <Typography>Lista de anexo</Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#ebebeb', borderRadius: '5px !important' }}>
                  <TableCell>Arquivo</TableCell>
                  <TableCell align="right">Tamanho</TableCell>
                  <TableCell align="right">Descartar</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                      files.map((e: any, index: number) => (
                        <TableRow>
                          <TableCell>
                            {e.name}
                          </TableCell>
                          <TableCell align="right" size="small">
                            {(e.size / 1000).toFixed(2)}
                            kb
                          </TableCell>
                          <TableCell align="right" size="small">
                            <IconButton
                              color="inherit"
                              aria-label="open drawer"
                              edge="start"
                              onClick={() => removeItem(index)}
                            >
                              <CloseIcon color="error" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                  }
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            disabled={saveLoading}
            onClick={() => setShowModal(true)}
          >
            <DeleteForeverOutlinedIcon color="error" fontSize="large" />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            disabled={saveLoading}
            onClick={() => EnviarSolicitacao()}
          >
            { !saveLoading
              ? <SaveOutlinedIcon sx={{ color: colors.themePrimary }} fontSize="large" />
              : <CircularProgress sx={{ color: colors.themePrimary }} color="inherit" />}
          </IconButton>
        </Grid>
      </Grid>
      <Modal open={showModal} hide={() => setShowModal(false)} title="Deletar solicitação?">
        <Grid
          container
          spacing={2}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Grid item>
            <ButtonTemplate
              cor="cyan"
              tonalidade={800}
              size="large"
              onClick={() => setShowModal(false)}
            >
              Não
            </ButtonTemplate>
          </Grid>
          <Grid item>
            <ButtonTemplate
              cor="cyan"
              tonalidade={800}
              size="large"
              onClick={() => history.goBack()}
            >
              Sim
            </ButtonTemplate>
          </Grid>
        </Grid>
      </Modal>
      <Modal open={showModalSize} hide={() => setShowModalSize(false)} title="Os arquivos podem ter no maximo 5mb">
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        >
          <ButtonTemplate
            cor="cyan"
            tonalidade={800}
            size="large"
            onClick={() => setShowModalSize(false)}
          >
            Ok
          </ButtonTemplate>
        </Box>
      </Modal>
    </>
  );
}
